<div class="HomePage">
  <h1>Your Green Shop Site!</h1>
</div>
<router-outlet></router-outlet>
